/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Ordinate = {
  value: string;
  direction: Ordinate.direction;
};
export namespace Ordinate {
  export enum direction {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
  }
}

